import currency from 'currency.js';

export const defaultCurrencyFormat = (
  numStr: string | number,
  showDecimals: boolean = true
) => {
  if (numStr === '') return '';

  const options = {
    fromCents: true,
  };

  let value = currency(numStr, options);

  if (!showDecimals) {
    value = currency(value.intValue / 100, { precision: 0 });
  }

  return value.format();
};
